import { render, staticRenderFns } from "./UserLoginLimit.vue?vue&type=template&id=715a8668&scoped=true"
import script from "./UserLoginLimit.vue?vue&type=script&lang=ts"
export * from "./UserLoginLimit.vue?vue&type=script&lang=ts"
import style0 from "./UserLoginLimit.vue?vue&type=style&index=0&id=715a8668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a8668",
  null
  
)

export default component.exports